import _ from 'lodash';
import { createReducer } from 'immutable-reducers';
import { actionTypes as reduxFormActions } from 'redux-form';
import { Map } from 'immutable';

import { FLASH_MESSAGE } from '../constants/actionTypes';
import * as actionTypes from '../constants/actionTypes';

export default createReducer(['session'], (session = Map(), action) => {
    let payload = action.payload;

    switch (action.type) {
        case actionTypes.FORM_DATA_LOAD:
            return session.setIn(['formData', payload.form], payload.id);

        case reduxFormActions.DESTROY:
            return session.deleteIn(['formData',action.form]);

        case actionTypes.DATA_LOAD_REQUEST:
            return session.setIn(['requesting', payload.resource], true);

        case actionTypes.DATA_LOAD_DONE:
        case actionTypes.DATA_LOAD_SUCCESS:
        case actionTypes.DATA_LOAD_ERROR:
            return session.deleteIn(['requesting', payload.resource]);

        case FLASH_MESSAGE.SET:
            return session.setIn(['flashMessage', action.id], {
                messageIds: _.isArray(action.messageIds) ? action.messageIds : [action.messageIds],
                theme: action.theme,
                titleId: action.titleId,
                ttl: action.ttl,
                params: action.params
            });

        case FLASH_MESSAGE.REMOVE:
            return session.deleteIn(['flashMessage', action.id]);

        default:
            break;
    }

    return session;
});
